var React = require('react');

function IconMinusInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"2.5","y":"9.063","width":"15","height":"1.875","rx":".938","fill":"#000","fillRule":"evenodd"}));
}

IconMinusInline.defaultProps = {"width":"20","height":"20"};

module.exports = IconMinusInline;

IconMinusInline.default = IconMinusInline;
